import { useInView } from 'motion/react';
import { useRef } from 'react';

interface UseScrollAnimationOptions {
  once?: boolean;
  amount?: number | 'some' | 'all';
}

export function useScrollAnimation(options: UseScrollAnimationOptions = {}) {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: options.once ?? true,
    amount: options.amount ?? 0.2,
  });

  return { ref, isInView };
}
